<template>
    <Toast/>
    <div class="row">
        <div class="col">
            <div class="row">
                <div class="col">
                    <h2 class="titre">Ajouter un mandat PSU</h2>
                </div>
            </div>
        </div>
    </div>
    <ModifierChamps ref="modifierChamps" :mandat="mandat" :isModifier="false"/>
    <ButtonBar @ajouter="ajouter" @fermer="fermer" :isSauvegardeEnCours="isSauvegardeEnCours"/>
    <DialogConfirmation ref="dialogConfirmation"/>
</template>

<script>
import axios from "axios";
import {mapGetters} from "vuex";
import ButtonBar from '../../../components/dossier/Ajouter/ButtonBarMandatPSU.vue';
import ModifierChamps from '../../../components/dossier/Modifier/ModifierChampsMandatPSU.vue'
import DialogConfirmation from '../../../components/Commun/DialogConfirmation.vue'

export default {
    name: "AjouterMandatPSU",
    components: {ModifierChamps, ButtonBar, DialogConfirmation,},
    computed: {
        ...mapGetters({
            jeton: "cardex/jeton",
      profil: 'cardex/profil',
            mandat: 'mandatPSU/mandat'
        }),
    },
    beforeMount() {
        axios.defaults.headers.common["cleProfil"] = this.profil.cle;
        this.$root.$refs.breadcrumbComp.ajout("Ajouter un mandat PSU");
        this.$store.commit('mandatPSU/MANDAT_STORE_STATE_RESET');
    },
    data() {
        return {
            isSauvegardeEnCours: false,
        };
    },
    methods: {
        ajouter() {
            this.$store.commit('mandatPSU/UPDATE_MANDAT', this.$refs.modifierChamps.getMandatLocal());
            this.$store.dispatch('mandatPSU/ajouterMandatPSUAction', {}).then((res) => {
                if ((res.status == 200 || res.status == 201 || res.status == 202) &&
                        res?.data?.messages.length == 0) {
                    this.$store.commit('mandatPSU/MANDAT', res.data.entite);
                    this.$router.push({
                        name: 'consulterMandatPSU',
                        params: {cle: res.data.entite.cle, site: res.data.entite.site}
                    });
                } else {
                    this.$root.$refs.messagesComp.messagesList = res.data.messages;
                }
            });
        },
        fermer() {
            this.$root.$refs.breadcrumbComp.rediriger();
        },
    },
    beforeRouteLeave(to, from, next) {
        return this.$refs.dialogConfirmation.confirmer(next, this.mandat,
            this.$refs.modifierChamps.getMandatLocal());
    },
};


</script>
